import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { showError, showSuccess } from "../utils/toastUtils";
import AuthAPI from "../api/authApi";
import { handleApiValidationError } from "../utils/apiErrorHandler";

function ResetPasswordForm() {
  const [searchParams, setSearchParams] = useSearchParams();
  const token = searchParams.get("token");
  const navigate = useNavigate();

  const [validToken, setValidToken] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState("");

  useEffect(() => {
    if (!token) {
      setMessage("Invalid reset link.");
      return;
    }

    // Check token validity from backend
    const verifyToken = async () => {
      try {
        const res = await AuthAPI.resetPasswordToken({ token });
        if (res.code === 200) {
          setValidToken(true);
        } else {
          showError(res.message);
        }
      } catch (err) {
        handleApiValidationError(err, setErrors);
      }
    };

    verifyToken();
  }, [token]);

  const validate = () => {
    const newErrors = {};
    if (!newPassword) {
      newErrors.newPassword = "New Password is required";
    }

    if (!confirmPassword) {
      newErrors.confirmPassword = "New Password is required";
    }

    if (newPassword !== confirmPassword) {
      newErrors.general = "Password & Confirm Password must be same.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    if (!validate()) {
      setIsLoading(false);
      return;
    }

    try {
      const payload = {
        newPassword,
      };

      const res = await AuthAPI.resetPassword(token, payload);
      if (res.code === 200) {
        showSuccess("Password reset successfully.");
        setTimeout(() => navigate("/"), 1500);
      } else {
        showError(res.data.message);
      }
    } catch (err) {
      showError("Error resetting password.");
    } finally {
      setIsLoading(false);
    }
  };

  if (!validToken) return <div className="alert alert-danger">{message}</div>;

  return (
    <div className="main-wrapper">
      <div className="account-content">
        <div className="row login-wrapper m-0">
          <div className="col-lg-6 p-0">
            <div className="login-content">
              <form method="post" onSubmit={handleSubmit}>
                <div className="login-userset">
                  <div className="login-logo logo-normal">
                    <img
                      src={`${process.env.PUBLIC_URL}/img/logo.png`}
                      alt="img"
                    />
                  </div>
                  <Link className="login-logo logo-white">
                    <img
                      src={`${process.env.PUBLIC_URL}/img/logo.png`}
                      alt="Img"
                    />
                  </Link>
                  <div className="login-userheading">
                    <h3>Reset Password</h3>
                    <h4>Update your password by entering your details.</h4>
                  </div>

                  {errors.general && (
                    <div className="col-12 mb-3">
                      <div className="alert alert-danger py-2">
                        {errors.general}
                      </div>
                    </div>
                  )}

                  <div className="mb-3">
                    <label className="form-label">
                      New Password <span className="required-indicator">*</span>
                    </label>
                    <div className="pass-group">
                      <input
                        type={showPassword ? "text" : "password"}
                        placeholder="Enter Password"
                        className="form-control"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                      />
                      <span
                        onClick={() => setShowPassword(!showPassword)}
                        className="ti toggle-password ti-eye-off text-gray-9"
                      />
                    </div>
                    {errors.newPassword && (
                      <span className="errors text-danger">
                        {errors.newPassword}
                      </span>
                    )}
                  </div>
                  <div className="mb-3">
                    <label className="form-label">
                      Confirm Password{" "}
                      <span className="required-indicator">*</span>
                    </label>
                    <div className="pass-group">
                      <input
                        type={showPassword ? "text" : "password"}
                        placeholder="Enter Password"
                        className="form-control"
                        autoComplete="new-password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                      />
                      <span
                        onClick={() => setShowPassword(!showPassword)}
                        className="ti toggle-password ti-eye-off text-gray-9"
                      />
                    </div>
                    {errors.confirmPassword && (
                      <span className="errors text-danger">
                        {errors.confirmPassword}
                      </span>
                    )}
                  </div>
                  <div className="form-login">
                    {!isLoading ? (
                      <button type="submit" className="btn btn-login">
                        Update Password
                      </button>
                    ) : (
                      <button
                        className="btn btn-primary-light w-100"
                        type="button"
                        disabled
                      >
                        <span className="spinner-border spinner-border-sm align-middle"></span>
                        Updating...
                      </button>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className="col-lg-6 p-0">
            <div className="login-img">
              <img
                src={`${process.env.PUBLIC_URL}/img/authentication/login-page-image.png`}
                alt="Img"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResetPasswordForm;
